module.exports = __webpack_public_path__ + "fa-brands-400.a1a749e89f578a49306e.svg";


//////////////////
// WEBPACK FOOTER
// E:/SafeCloud-FrontEnd/WebConsorcioPimentel/src/assets/plugins/FontAweson/webfonts/fa-brands-400.svg
// module id = ../../../../../src/assets/plugins/FontAweson/webfonts/fa-brands-400.svg
// module chunks = styles